import React from 'react';
import { TimkenUnit } from '../../components/bearing-search/types/types';
import { handleActionError } from '../utils/engineering-tools';

export type InstallationCalculationsState = {
	units: TimkenUnit;
};

export const initialInstallationState: InstallationCalculationsState = {
	units: 'M',
};

export type InstallationCalculationsAction =
	| { type: 'change_unit'; payload: TimkenUnit }
	| { type: 'reset'; payload?: InstallationCalculationsState };

const installationCalculationReducer: React.Reducer<
	InstallationCalculationsState,
	InstallationCalculationsAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_unit': {
			return {
				...state,
				units: action.payload,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialInstallationState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default installationCalculationReducer;
